import {
  Node_Type
} from "./../../ricos-schema/next-schema/index.js";
const doPrompt = async ({
  prompt: userPrompt,
  document,
  selection,
  makeRequest,
  widgetType
}) => {
  const promptIdFromQuery = new URLSearchParams(window.location.search).get("ricosPromptId");
  const promptId = promptIdFromQuery && looksLikeUUID(promptIdFromQuery) ? promptIdFromQuery : "219f7fa1-d5a4-4089-ae29-e7d9008c753a";
  const prompt = widgetType ? `${userPrompt} 

 **IMPORTANT**
The type of widget to create should be of type ${widgetType}, RELEVANT to the content, its styling and request mentioned above` : userPrompt;
  try {
    const requestBody = {
      ricosConversation: {
        promptId,
        document,
        documentSelection: { ...selection },
        enabledTools: [],
        returnMetadata: true,
        files: [],
        message: prompt
      }
    };
    const response = await makeRequest(
      `https://www.wixapis.com/ricos/v1/ricos-conversations/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-ndjson"
        },
        body: JSON.stringify(requestBody)
      }
    );
    const requestId = response.headers.get("x-wix-request-id");
    if (requestId) {
      console.log(
        "\x1B[44m\x1B[97m RICOS PROMPT \x1B[0m",
        prompt,
        `https://grafana.wixpress.com/d/dewd4kmq6f400b/ricos-ai-assistant?var-selected_request_id=${requestId}`
      );
    }
    const body = await response.json();
    const htmlNode = body.richContent?.nodes?.find((node) => node.type === Node_Type.HTML);
    const html = htmlNode?.htmlData?.html;
    const containerData = htmlNode?.htmlData?.containerData ?? null;
    if (!response.ok || !html) {
      return {
        type: "ERROR",
        error: "Error generating HTML"
      };
    }
    return {
      type: "SUCCESS",
      html,
      containerData
    };
  } catch (error) {
    return {
      type: "ERROR",
      error: error instanceof Error ? error.message : "Error generating HTML"
    };
  }
};
const looksLikeUUID = (str) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(str);
export {
  doPrompt
};
//# sourceMappingURL=do-prompt.js.map
